var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.shouldDisplayDrawer
        ? _c("burger-menu-icon", { attrs: { "on-click": _vm.openDrawer } })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldDisplayDrawer
        ? _c(
            "button",
            {
              staticClass: "burger-menu__close",
              attrs: { "on-click": _vm.closeDrawer }
            },
            [_c("i", { staticClass: "fa fa-times" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "drawer" },
        [
          _c(
            "transition",
            { attrs: { name: "fade-in-from-top" } },
            [
              _c("burger-menu-drawer", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldDisplayDrawer,
                    expression: "shouldDisplayDrawer"
                  }
                ],
                attrs: {
                  menu: _vm.structuredMenu,
                  "social-links": _vm.socialLinks,
                  "on-close": _vm.closeDrawer
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13a0cd0a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0cd0a","hasScoped":true,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/burger-menu/BurgerMenu.vue
// module id = 122
// module chunks = 0